import { EntityType } from "@/services/hooks/entities/useEntityType";
import { CsmRenewalConfidenceLevel } from "@/pages/deals/types";

type EnumObject = Record<string, number | string>;

export interface EnumFieldConfig {
  namespace: string;
  subKey: string;
  enumType: EnumObject;
}

// Resolved through a function rather than a module-level object keyed by
// EntityType: a computed enum key is evaluated at module-init, which throws
// under a circular import if the enum's module has not finished loading.
export const getEnumFieldConfig = (
  entityType: EntityType,
  fieldName: string
): EnumFieldConfig | undefined => {
  if (
    entityType === EntityType.CONTRACT &&
    fieldName === "csmRenewalConfidenceLevel"
  ) {
    return {
      namespace: "deals",
      subKey: "levels",
      enumType: CsmRenewalConfidenceLevel
    };
  }
  return undefined;
};
